export default "__VITE_ASSET__Dy7kf4cw__"